<script>
import SidebarLink from '@/components/sidebar/SidebarLink'
import { collapsed, toggleSidebar, sidebarWidth } from './state'
import VueCookies from "vue-cookies";
import { ref, watch, inject } from "vue";
import barcodeService from "@/services/BarcodeService";
import router from "@/router";
import CustomerColoursDataService from "@/services/CustomerColoursDataService";
import BarcodeService from "@/services/BarcodeService";

export default {
  props: {},
  components: { SidebarLink },
  methods: {

    // Closes the responsive menu by unticking the related invisible checkbox
    handleMenuClick(event) {
      const checkbox = document.getElementById('mobile-menu-toggle');
      if (checkbox) {
        checkbox.checked = false;
      }
    },

    onLogout() {
//      this.$store.dispatch('logout')
    },

    searchIdFieldKeypress(event){

      let key = ( event.key || '' ).toLowerCase();
      let type;
      let searchIdButtons    = document.getElementsByClassName('search-type')[0];

      switch( key ) {
        case 'c':
          //console.log('calling customer');
          type = 'customer';
          break;
        case 'o':
          //console.log('calling order');
          type = 'order';
          break;
        case 'g':
          //console.log('calling garment');
          type = 'garment';
          break;
      }

      if( type ) {
        searchIdButtons.value = type;
        searchIdButtons.click();
        //console.log('click event call', searchIdButtons);
      }
      else
      {
        return false;
      }

    },
    searchIdButtonsClick(event){
      let searchIdField      = document.getElementById('id-search');
      //console.log('searchIdField',searchIdField.value);

      if( ! searchIdField.value.trim() ) {
        event.preventDefault();
        return false;
      }
    }
  },
  mounted() {
    // Select all <a> tags inside elements with class ".menu"
    const menuLinks = document.querySelectorAll('.navigation-links a');

    // Attach a click event listener to each <a> tag
    menuLinks.forEach((link) => {
      link.addEventListener('click', this.handleMenuClick);
    });
  },
  setup() {
    const sessionUser = ref({
      id: 0,
      username: "",
      userlabel: "",
      workstation: "",
    })

    const workstationID = ref(VueCookies.get('epos2_workstationid'));
    const session = ref({
      id: 0,
      username: "",
    });

    const globalBarcodeSearch = ref("")
    const barcodeScanStatusMessaqe = ref("Set focus for scanning")

    const eposBase = process.env.VUE_APP_EPOS_API_BASE

    const updateBarcodeStatusMessage = (message) => {
      barcodeScanStatusMessaqe.value = message
    }

    const redirectToDetails = (elt) => {
      console.log(elt)
    }

    watch(globalBarcodeSearch, async (barcode) => {
        const barcodeDetails = barcodeService.getBarcodeDetails(barcode)
        barcodeService.recordBarcode(barcodeDetails)
        if (barcodeDetails.type === "order") {
            router.push("/orders/" + barcodeDetails.id)
        } else if (barcodeDetails.type === "customer") {
            router.push("/customers/" + barcodeDetails.id)
        } else if (barcodeDetails.type === "garment") {
          router.push("/garments/" + barcodeDetails.id)
        } else if (barcodeDetails.type === "rfid") {
            router.push("/search/" + barcodeDetails.id)
        } else if (barcodeDetails.type === "item") {

          BarcodeService.getByBarcode(barcodeDetails.barcode, barcodeDetails.type)
              .then(response => {
                if( response.data.data.order_detail && response.data.data.order_detail[0].order_id ) {
                  var urlParams = new URLSearchParams({
                    page: 'order',
                    mode: 'process',
                    order_id: response.data.data.order_detail[0].order_id,
                    orderitem: response.data.data.order_detail[0].orderitemid
                  });

                  let url = process.env.VUE_APP_EPOS_API_BASE+'/index.php?' + urlParams.toString();
                   window.open(
                       url,
                      "_self"
                  );
                }
              })
              .catch(e => {
                console.log(e);
              });
      }
    })

    const serializedObject = localStorage.getItem("sessionDetails")
    if (serializedObject) {
      sessionUser.value = JSON.parse(serializedObject)
    }

    return { collapsed, toggleSidebar, sidebarWidth, workstationID, session, globalBarcodeSearch,
      barcodeScanStatusMessaqe, updateBarcodeStatusMessage, redirectToDetails, eposBase, sessionUser}
  },

}
</script>

<template>
  <input type="checkbox" id="mobile-menu-toggle" />
  <div class="sidebar" :style="{ width: sidebarWidth }">

    <nav class="epos-navigation">

      <div id="lrLogoWrapper">
        <img id="lrLogo" src="/resources/images/laundryrepublic-logo.png?v=1" />
      </div>

      <p id="eposLogo">
        <label for="mobile-menu-toggle"><a class="mobile-menu-trigger mobile-only">
          <i class="fas fa-bars"></i>
        </a></label>
        <span>E</span>
        <span>P</span>
        <span>O</span>
        <span>S</span>
      </p>

      <div class="toggle-menu">
        <div class="user-info gutter">
          <div class="user-name">
            <i class="fas fa-user"></i>
            <span>{{ sessionUser.userlabel }} </span>
          </div>
          <div class="workstation-name">
            <i class="fas fa-desktop"></i>
            <span>{{ sessionUser.workstation}}</span>
          </div>
          <div class="message-inbox">
            <i class="fas fa-envelope-open-text"></i>
            <span>No messages</span>
          </div>
        </div>

        <form class="id-search" method="post" :action="eposBase + '/dashboard/search'">
          <h4>ID Search</h4>
          <input type="number" name="identifier" id="id-search" @keypress="searchIdFieldKeypress"/>
          <div class="search-types">
            <button class="search-type" type="submit" name="type" value="customer"
                    title="Search for a Customer" @click="searchIdButtonsClick()">
              <i class="fas fa-user-tag"></i>
            </button>
            <button class="search-type" type="submit" name="type" value="order"
                    title="Search for an Order"  @click="searchIdButtonsClick()">
              <i class="fas fa-shopping-bag"></i>
            </button>
            <button class="search-type" type="submit" name="type" value="garment"
                    title="Search for a Garment"  @click="searchIdButtonsClick()">
              <i class="fas fa-tshirt"></i>
            </button>
          </div>
        </form>

        <div class="barcode-search">
          <h4>Barcode Search</h4>
          <input type="text" id="barcode-search" name="globalBarcodeSearch"
                 autofocus="true"
                 v-model="globalBarcodeSearch"
                 autocomplete="off"
                 @focus="updateBarcodeStatusMessage('Ready to scan')"
                 @blur="updateBarcodeStatusMessage('Set focus for scanning')"
          />
          {{ barcodeScanStatusMessaqe }}
        </div>

        <ul class="navigation-links">
          <li>
            <SidebarLink to="/dashboard" icon="fas fa-clipboard-check">Dashboard</SidebarLink>
          </li>
          <li>
            <SidebarLink to="/customers" icon="fas fa-user-friends">Customers</SidebarLink>
          </li>

          <li>
            <SidebarLink to="/process" icon="fas fa-list-ol">Process</SidebarLink>
          </li>
          <!--<li>
            <SidebarLink to="/assemble-orders" icon="fas fa-clipboard-check">Old Assemble</SidebarLink>
          </li>

          <li class="desktop-only">
            <SidebarLink to="/assemble" icon="fas fa-clipboard-check">Old Towel Assemble</SidebarLink>
          </li>
          -->
          <li>
            <SidebarLink to="/assemble-order" icon="fas fa-clipboard-check">Assemble - Order</SidebarLink>
          </li>
          <li>
            <SidebarLink to="/assemble-towel" icon="fas fa-clipboard-check">Assemble - Towels</SidebarLink>
          </li>
          <li>
            <SidebarLink to="/rfid/dashboard" icon="fas fa-broadcast-tower">RFID Dashboard</SidebarLink>
          </li>
          <li>
            <SidebarLink to="/orders/all" icon="fas fa-layer-group">All Orders</SidebarLink>
          </li>

          <li>
            <SidebarLink to="/orders/live" icon="fas fa-layer-group">Live Orders</SidebarLink>
          </li>

          <li>
            <SidebarLink to="/logistics" icon="fas fa-luggage-cart">Logistics</SidebarLink>
          </li>

          <li>
            <SidebarLink to="/logout" icon="fas fa-door-open">Log Out</SidebarLink>
          </li>

        </ul>
      </div>
    </nav>

    <!--
    <span
        class="collapse-icon"
        :class="{ 'rotate-180': collapsed }"
        @click="toggleSidebar"
    >
      <font-awesome-icon :icon="['fas', 'angle-double-left']" />
    </span>

    -->
  </div>
</template>

<style>
:root {
  --sidebar-bg-color: #2b88a0;
  --sidebar-item-hover: #48b9ef;
  --sidebar-item-active: #26778c;

  --primary-color: #2b88a0;
  --red-color: #E31A22;
  --green-color: #c3e6cb;
  --light-green-color: #90ee90;
  --light-red-color: #ffb6c1;
  --disabled-color: #d3d3d3;

  --form-border-color: #eeeeee;
  --form-shadow-color: #cccccc;

  --success-color: #90ee90;
  --error-color: #E31A22;
  --handling-color: #ffc107;

  --rewarding-color: #ce1584;
}
</style>

<style scoped>
.sidebar {
  color: white;
  background: linear-gradient(160deg, #48b9ef, #2b88a0 30%, #26778c 0, #10333c);

  float: left;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 0.5em;

  transition: 0.3s ease;

  display: flex;
  flex-direction: column;
  font-size: 13px;

}

.sidebar h1 {
  height: 2.5em;
}

#lrLogoWrapper img {
  width: 100%;
}

#eposLogo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px;
  margin: 5px 0 20px;
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  text-shadow: 2px 2px 2px rgba(0,0,0,.3);
  transform-origin: 0 0;
}

.collapse-icon {
  position: absolute;
  bottom: 0;
  padding: 0.75em;

  color: rgba(255, 255, 255, 0.7);

  transition: 0.2s linear;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: 0.2s linear;
}


.epos-navigation #lrLogoWrapper {
  padding: 20px 20px 0;
}

.epos-navigation div.user-info i {
  display: inline-block;
  width: 18px;
}
.epos-navigation div.user-info {
  border-bottom: 1px solid hsla(0,0%,78.4%,.5);
  padding-bottom: 10px;
}
.epos-navigation .gutter {
  margin: 0 20px;
}

.epos-navigation ul.navigation-links {
  list-style: none inside none;
  padding: 0;
  margin: 10px 0;
}

.epos-navigation ul.navigation-links li {
  display: block;
  overflow: hidden;
  border-top: 1px solid hsla(0,0%,78.4%,.5);
  padding: .3rem;
}
.epos-navigation ul.navigation-links li:first-child {
  border-top: none;
}

.epos-navigation ul.navigation-links li a {
  display: block;
  margin: 0.5rem;
}

.epos-navigation ul.navigation-links li:hover {
  background: rgba(142,212,245,.3);
}

.epos-navigation a, .epos-navigation span {
  text-decoration: none;
  color: #fff;
}

.epos-navigation ul.navigation-links li a span {
  display: block;
  margin: 0 20px;
  box-sizing: border-box;
  font-weight: 400;
  color: #ecf8fd;
}
.epos-navigation .navigation-links a span {
  text-transform: uppercase;
  font-size: 10px;
  line-height: 35px;
}

.epos-navigation ul.navigation-links li a span i {
  line-height: 35px;
  width: 25px;
  font-size: 16px;
  margin-right: 1rem;
  text-align: center;
  display: inline-block;
}

.epos-navigation ul.navigation-links li:hover ul.sub-menu {
  transition: opacity .3s ease-in-out .3s;
  list-style: none inside none;
  opacity: 1;
}

.epos-navigation ul.navigation-links ul.sub-menu {
  font-size: 11px;
}

.epos-navigation ul.navigation-links ul.sub-menu a {
  padding: 0.5rem;
}

.epos-navigation .barcode-search input[type=number],
.epos-navigation .barcode-search input[type=text],
.epos-navigation .id-search input[type=number],
.epos-navigation .id-search input[type=text] {
  box-sizing: border-box;
  width: 100%;
  background: hsla(0,0%,100%,.3);
  color: #fff;
  border: 0;
}
.epos-navigation input {
  line-height: 1.15;
}

.mobile-only {
  display : initial;
}

.desktop-only {
  display : none;
}

.epos-navigation .barcode-search,
.epos-navigation .id-search {
  margin: 10px 20px;
}
.epos-navigation .barcode-search h4,
.epos-navigation .id-search h4 {
  font-size: 13px;
  margin: 0 0 3px;
  font-weight: bold;
}

.epos-navigation .id-search .search-types .search-type {
  color: #fff;
  border: none;
  border-left: 1px solid hsla(0,0%,78.4%,.5);
  background: transparent;
  line-height: 30px;
  flex-grow: 1;
  cursor: pointer;
}

.epos-navigation .id-search .search-types {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}

.epos-navigation .id-search .search-types .search-type:first-child {
  border-left: none;
}

.mobile-only {
  display: none;
}

#eposLogo label {
  display: none;
}

@media screen and (max-width: 1024px) {

  .sidebar {
    width: 100% !important;
    height: 45px;
  }

  #eposLogo {
    display: block;
  }
  .mobile-menu-trigger {
    margin-right: 20px;
  }
  #mobile-menu-toggle {
    display: none;
  }
  #mobile-menu-toggle:checked + .sidebar {
    height: auto;
  }

  .toggle-menu {
    display: none;
  }

  #mobile-menu-toggle:checked + .sidebar .toggle-menu {
    display: block;
  }

  #lrLogoWrapper {
    display: none;
  }
  .epos-navigation {
    display: block;
    position: fixed;
    height: auto;
    width: 100%;
    width: 100vw;
    top: 0;
    left: 0;
  }

  .epos-navigation.mobile-menu-open .barcode-search,
  .epos-navigation.mobile-menu-open .id-search,
  .epos-navigation.mobile-menu-open ul.navigation-links,
  .epos-navigation.mobile-menu-open ul.navigation-links li.mobile-only {
    display: block;
  }

  .epos-navigation ul.navigation-links {
    list-style: none inside none;
    padding: 0;
    margin: 10px 0;
  }

  .mobile-only {
    display: block;
  }

  .collapse-icon {
    display: none;
  }

  .id-search,
  .barcode-search {
    max-width: 250px;
  }

  #eposLogo label {
    display: inline-block !important;
  }


}

</style>
